<template>
  <div class="page">
    <div class="main">
      <div class="login">注册</div>
      <div class="ph-input" style="margin-top:0px;">
        <van-field v-model="userPhone" type="tel" left-icon="phone-circle-o" clear-trigger="always" class="ph-t" clearable
          placeholder="请输入手机号" />
      </div>

      <div class="ph-input" style="margin-top:0px;">
        <van-field v-model="passWold"  clear-trigger="always" class="ph-t" clearable
          placeholder="请输入注册密码" />
      </div>
      <!-- <div class="ph-input" style="margin-top:0px;">
        <van-field v-model="smsCode" type="tel" left-icon="description" clear-trigger="always" class="ph-t" clearable
          placeholder="验证码">
          <template #button>
            <van-button v-if="!countdown" size="small" type="primary" @click="getCode">发送验证码</van-button>
            <van-button v-if="countdown" size="small" type="primary" disabled>{{ count }}S后重新获取</van-button>
          </template>
        </van-field>
      </div> -->

      <div class="checkbox-info">
        <van-row>
          <van-col :span="2" style="text-align:center;">
            <van-checkbox v-model="checked"></van-checkbox>
          </van-col>
          <van-col :span="22" style="font-size:14px;">
            <span>我已阅读并同意</span>
            <span @click="aaaaa" style="color:#FF5700;line-height:26px;">《注册协议》</span>
            <span @click="shouhou" style="color:#FF5700;line-height:26px;">《售后协议》</span>
            <span>和</span>
            <span @click="bbbb" style="color:#FF5700;cursor: pointer;">《隐私协议》</span>
          </van-col>
        </van-row>
      </div>

      <van-button class="bu_tn-a" round block type="info" native-type="submit" @click="onSubmit">注册登录</van-button>
      <div class="tis">温馨提示</div>
      <div class="tis-small">1、手机绑定后，下次可用手机号直接登录查询。</div>
      <div class="tis-small">2、注册后 你可在 我的 页面进行注销信息。</div>
    </div>
    <van-dialog v-model="reacheShow" title="图形验证码" :show-confirm-button="false">
      <div @click="refreshCode">
        <s-identify :identify-code="identifyCode" />
      </div>
      <div class="captcha">
        <input v-for="(c, index) in ct" :key="index" ref="input" v-model="ct[index]" type="number"
          :style="{ borderBottomColor: index <= cIndex ? '#00c777' : '' }" :disabled="loading"
          @input="e => { onInput(e.target.value, index) }" @keydown.delete="e => { onKeydown(e.target.value, index) }"
          @focus="onFocus">
      </div>
      <div class="btn-vis">
        <van-button type="primary" class="dialog-btn2" @click="getCode">获取验证码</van-button>
        <van-button type="primary" class="dialog-btn3" @click="closeShow">关闭</van-button>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import { wxRequest } from '@/api/user'
import { Toast, Dialog } from 'vant'
import SIdentify from '@/components/canvas.vue'
export default {
  components: {
    SIdentify
  },
  data() {
    return {
      passWold:'',
      checked: false,
      userPhone: null,
      smsCode: '',
      iccid: localStorage.getItem('iccid'),
      recordLoginText: localStorage.getItem('recordLoginText'),
      reacheShow: false,
      loading: false,
      identifyCodes: '1234567890',
      ct: ['', '', '', ''],
      identifyCode: '',
      countdown: false,
      count: null,
      timer: null

    }
  },
  computed: {
    ctSize() {
      return this.ct.length
    },
    cIndex() {
      let i = this.ct.findIndex(item => item === '')
      i = (i + this.ctSize) % this.ctSize
      return i
    },
    lastCode() {
      return this.ct[this.ctSize - 1]
    }
  },
  watch: {
    cIndex() {
      this.resetCaret()
    },
    lastCode(val) {
      if (val) {
        this.$refs.input[this.ctSize - 1].blur()
      }
    }
  },
  mounted() {
    document.onkeydown = (e) => {
      if (e.keyCode == 8) { // 这是delete健，当然也可以根据自己的需求更改
        this.deleteKeyup()// 操作方法
      }
    }
  },
  methods: {
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min)
    },
    refresh() {
      this.reacheShow = true
      this.refreshCode()
    },
    // 切换验证码
    refreshCode() {
      this.identifyCode = ''
      this.makeCode(this.identifyCodes, 4)
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[this.randomNum(0, this.identifyCodes.length)]
      }
    },
    onInput(val, index) {
      val = val.replace(/\s/g, '')
      if (index === this.ctSize - 1) {
        this.ct[this.ctSize - 1] = val[0] // 最后一个码，只允许输入一个字符。
        this.getCode()
      } else if (val.length > 1) {
        let i = index
        for (i = index; i < this.ctSize && i - index < val.length; i++) {
          this.ct[i] = val[i]
        }
        this.resetCaret()
      }
    },
    // 重置光标位置。
    resetCaret() {
      this.$refs.input[this.ctSize - 1].focus()
    },
    onFocus() {
      // 监听 focus 事件，将光标重定位到“第一个空白符的位置”。
      let index = this.ct.findIndex(item => item === '')
      index = (index + this.ctSize) % this.ctSize
      this.$refs.input[index].focus()
    },
    onKeydown(val, index) {
      if (val === '') {
        // 删除上一个input里的值，并对其focus。
        if (index > 0) {
          this.ct[index - 1] = ''
          this.$refs.input[index - 1].focus()
        }
      }
    },
    deleteKeyup() {
      this.$refs.input[this.ctSize - 1].focus()
    },
    sendCaptcha() {
      // 此时无法操作 input。。
      this.loading = true
      setTimeout(() => {
        this.loading = false
        this.$nextTick(() => {
          this.reset()
        })
      }, 3000)
    },
    reset() {
      // 重置。一般是验证码错误时触发。
      this.ct = this.ct.map(item => '')
      this.resetCaret()
    },
    closeShow() {
      this.reacheShow = false
    },
    getCode() {
      this.closeShow()
      // if (!String(this.ct.join(''))) {
      //   Toast.fail('请输入验证码')
      //   return
      // } else if (String(this.ct.join('')) !== this.identifyCode) {
      //   Toast.fail('验证码不正确!')
      //   return
      // }
      if(!this.passWold){
        Toast.fail('请输入登录密码！')
        return
      }
      if (!(/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(this.userPhone))) {
        Toast.fail('请填写正确的手机号')
        return
      }
      wxRequest('/bindPhone/sms/code', { userPhone: this.userPhone }, 'post').then(res => {
        if (res.data.code === '200') {
          this.countDown()
          Toast.success('发送成功')
        } else {
          Toast.fail(res.data.message)
        }
      })
    },
    countDown() {
      const TIME_COUNT = 59
      if (!this.timer) {
        this.count = TIME_COUNT
        console.log(this.count)
        this.countdown = false
        this.timer = setInterval(() => {
          if (this.count > 0) {
            this.count--
            this.countdown = true
          } else {
            this.countdown = false
            clearInterval(this.timer)
            this.timer = null
          }
        }, 1000)
      }
    },
    onSubmit() {
      if (!this.checked) {
        Toast.fail('请勾选隐私和注册协议');
        return
      }
      if (!(/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(this.userPhone))) {
        Toast.fail('请填写正确的手机号')
        return
      }
      Toast.success('注册成功')
      localStorage.setItem('myLoginPhone', this.userPhone);
      this.$router.push({ path: '/liu/userInfo' });

      // wxRequest('bindPhone/phone/new/success/no', { userPhone: this.userPhone, smsCode: this.smsCode, iccid: localStorage.getItem('iccid') }, 'post').then(res => {
      //   if (res.data.code === '200') {
      //     Toast.success('注册成功')
      //     localStorage.setItem('myLoginPhone', this.userPhone);
      //     this.$router.push({ path: '/user/me' });
      //   } else {
      //     Toast.fail(res.data.message)
      //   }
      // })
    },
    loginSumbit() {
      var params = {
        iccid: this.iccid,
        userPhone: this.userPhone,
        smsCode: this.smsCode
      }
      wxRequest('/bindPhone/phone/new/success', params, 'post').then(res => {
        if (res.data.code === '200') {
          this.$router.replace('/newUser/firstHome')
        } else {
          Toast.fail(res.data.message)
        }
      })
    },
    shouhou() {
      Dialog.confirm({
        title: '售后协议',
        width: '90%',
        showCancelButton: false,
        messageAlign: 'left',
        confirmButtonColor: '#ee0a24',
        message: `
        本商城为您提供便捷的退/换货服务， 受到广大顾客的一致好评，据统计有80%以上的顾客选择网上申请的方式进行退/换货，您可以随时通过网上进行申请，我们将及时为您处理。
第一步：联系本商城客服
如果您需要办理退换货，请依照退换货政策联系本商城在线售后客服，提供您的订单编号或相关订单信息（收货人、联系方式等）申请退换货服务。

重要提示：为了尽快帮您解决问题，请您在第一时间与我们的客服联系，以便我们能及时为您办理相关手续。切勿在未与本商城客服联系前直接将商品寄出！

第二步：退换货条件
1. 注：图片及信息仅供参考，不属质量问题。因拍摄灯光及不同显示器色差等问题可能造成商品图片与实物有一定色差，这不属于质量问题，请以实物为准。
2. 非质量问题商品未受污损，不影响我司进行二次销售，且外包装完好无损（包括包裹填充物及外包装盒），附件、说明书、保修单、赠品等的完整可申请退换货服务。
3. 如果商品存在质量问题，请务必提供质量问题点图片及相关文字说明，并与客服确认。
4. 退换货所产生的运费，除需要本商城承担的部分以外，请您与本商城售后部客服确认运费金额及退款方式且预先垫付，请勿选择到付的运费支付方式！
5. 如果该产品有附加的赠品，请将全新完好的赠品一同退回。如赠品不能退回，将按照本商城网站的实际销售价格在退款中扣除。

第三步：将需退还的商品邮寄回本商城
重要提示：
1. 请确保产品外包装、内附配件齐全。内附配件包括：防潮纸及说明书、配送单、发票等。
2. 退换货运费说明：

  退换货时间说明	对象	退换货类型	运费承担者	办理周期
7日内退换 30日内换货	所有类型  	非包邮商品，因个人喜好等原因需要退换	来回运费买家承担	收到寄回的商品后，
会短信通知您确认收货，
并办理完成退换货或者退款
（自客户签收之日起计算）		包邮商品，因个人喜好等原因需要退换	来回运费买家承担	
		商品存在质量问题	来回运费由本商城承担	
退款流程
为了更快地处理您的退款要求，请您直接联系本商城在线售后客服
1．顾客联系本商城客服，提供订单信息，提出退换货申请；
2．顾客与本商城客服确认退换货事项后，根据订单状态与客服确认退款方式，并将商品邮寄回本商城；
退款方式：与支付方式相同，以顾客的支付方式退回相应的支付账号中
a\ 支付宝、财付通：如订单交易未成功，可直接通过支付宝申请退款；如订单交易已成功，则提供支付宝账号，本商城将以即时到帐的方式退到顾客的支付宝账号内；
b\ 银行汇款退款：提供银行帐号，并注明开户行、分行名称以及收款人姓名；
c\ 邮政汇款退款：提供收款人姓名、详细地址和邮政编码
d\ 电子银联退款：提供银行帐号，并注明开户行、分行名称以及收款人姓名

3．本商城收到商品后短信通知顾客，并在1-2个工作日内完成商品完成质检审核后进行退款操作。
4．如有异常情况出现，客服会在第一时间与您联系确认信息重新操作；
5．顾客查收货款。

注意事项
1．第三方支付平台帐号（支付宝帐号、财付通帐号等）处理退款，顾客可登陆第三方平台通过交易号、订单号等查询。
2．其他退款方式由于跨行或邮政汇款等原因，款项可能不会立刻到帐，因此请您耐心等候或与名鞋库电话联系确认。
3．积分、礼券等非现金的馈赠款项，在退换货时不做退款处理，只能返还原兑换积分，或补发礼券。
`,
      }).then(() => {
        // on confirm
      }).catch(() => {
        // on cancel
      });
    },



    aaaaa() {
      Dialog.confirm({
        title: '关于客户注册协议',
        width: '90%',
        showCancelButton: false,
        messageAlign: 'left',
        confirmButtonColor: '#ee0a24',
        message: `本用户注册协议（以下简称“本协议”）系由用户（以下简称“您”）与（以下简称“我们”）就提供的电商平台（以下简称“本平台”）所订立的相关权利义务规范。请您在申请注册之前，应当认真阅读本协议。请您务必审慎阅读、充分理解各条款内容，如您对协议有任何疑问，可向本平台客服咨询。
当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后，即表示您已充分阅读、理解并接受本协议的全部内容，并与我们达成一致，成为本平台“用户”。阅读本协议的过程中，如果您不同意本协议或其中任何条款约定，您应立即停止注册程序。
一、协议签约主体
1.1平等主体：本协议由您与本平台经营者共同缔结，本协议对您与本平台经营者均具有合同效力。
1.2主体信息：本平台经营者是指经营本平台的各法律主体，您可随时查看本平台各网站首页底部公示的证照信息以确定与您履约的我们主体。本协议项下，本平台经营者可能根据本平台的业务调整而发生变更，变更后的本平台经营者与您共同履行本协议并向您提供服务，本平台经营者的变更不会影响您本协议项下的权益。本平台经营者还有可能因为提供新的本平台服务而新增，如您使用新增的本平台服务的，视为您同意新增的本平台经营者与您共同履行本协议。发生争议时，您可根据您具体使用的服务及对您权益产生影响的具体行为对象确定与您履约的主体及争议相对方。
二、 账户注册与使用
2.1 用户资格
您确认，在您开始注册程序使用本平台服务前，您应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力。若您不具备前述与您行为相适应的民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的一切后果。
2.2 账户说明
当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后，您可获得本平台账户并成为本平台用户。
本平台只允许每位用户使用一个本平台账户。如有证据证明或我们根据本平台规则判断您存在不当注册或不当使用多个本平台账户的情形，本平台可采取冻结或关闭账户、取消订单、拒绝提供服务等措施，如给本平台及相关方造成损失的，您还应承担赔偿责任。
您有权使用您设置或确认的我们会员名、邮箱、手机号码（以下简称“账户名称”）及您设置的密码（账户名称及密码合称“账户”）登录本平台。
由于您的账户关联您的个人信息及本平台商业信息，您的账户仅限您本人使用。未经本平台同意，您直接或间接授权第三方使用您账户或获取您账户项下信息的行为无效。如我们根据本平台规则中约定的违约认定程序及标准判断您账户的使用可能危及您的账户安全或本平台信息安全的，本平台可拒绝提供相应服务或终止本协议。
作为本平台经营者，为使您更好地使用本平台的各项服务，保障您的账户安全，我们可要求您按要求及我国法律规定完成实名认证。
2.3 注册信息管理
2.3.1 真实合法
在使用本平台服务时，您应当按本平台页面的提示准确完整地提供您的信息（包括您的用户名、电子邮件地址、联系电话），以便我们或其他用户与您联系。您了解并同意，您有义务保持您提供信息的真实性及有效性。
2.3.2 更新维护
您应当及时更新您提供的信息，在法律有明确规定要求我们作为平台服务提供者必须对部分用户（如平台卖家等）的信息进行核实的情况下，我们将依法不时地对您的信息进行检查核实，您应当配合提供最新、真实、完整、有效的信息。
如我们按您最后一次提供的信息与您联系未果、您未按我们的要求及时提供信息、您提供的信息存在明显不实或行政司法机关核实您提供的信息无效的，您将承担因此对您自身、他人及我们造成的全部损失与不利后果。我们可向您发出询问或要求整改的通知，并要求您进行重新认证，直至中止、终止对您提供部分或全部本平台服务，我们对此不承担责任。
2.4 账户安全规范
您的账户为您自行设置并由您保管，我们任何时候均不会主动要求您提供您的账户密码。因此，建议您务必保管好您的账户，并确保您在每个上网时段结束时退出登录并以正确步骤离开本平台。
账户因您主动泄露或因您遭受他人攻击、诈骗等行为导致的损失及后果，我们并不承担责任，您应通过司法、行政等救济途径向侵权行为人追偿。
三、 本平台服务及规范
3.1交易秩序保障
您有权在本平台上享受店铺管理、商品或服务的销售与推广、商品及服务的购买与评价、交易争议处理等服务。我们提供的服务内容众多，具体您可登录本平台浏览。您应当遵守诚实信用原则，确保您所发布的商品或服务信息真实、与您实际所销售的商品或提供的服务相符，并在交易过程中切实履行您的交易承诺。
您应当维护本平台市场良性竞争秩序，不得贬低、诋毁竞争对手，不得干扰本平台上进行的任何交易、活动，不得以任何不正当方式提升或试图提升自身的信用度，不得以任何方式干扰或试图干扰本平台的正常运作。
3.2商品或服务的购买与评价
当您在本平台购买商品或服务时，请您务必仔细确认所购商品的品名、价格、数量、型号、规格、尺寸或服务的时间、内容、限制性要求等重要事项，并在下单时核实您的联系地址、电话、收货人等信息。如您填写的收货人非您本人，则该收货人的行为和意思表示产生的法律后果均由您承担。
您的购买行为应当基于真实的消费需求，不得存在对商品或服务实施恶意购买、恶意维权等扰乱本平台正常交易秩序的行为。基于维护本平台交易秩序及交易安全的需要，我们发现上述情形时可主动执行关闭相关交易订单等操作。
您有权在本平台提供的评价系统中对与您达成交易的其他用户商品及服务进行评价。您应当理解，您在本平台的评价信息是公开的，如您不愿意在评价信息中向公众披露您的身份信息，您有权选择通过匿名形式发表评价内容。
您的所有评价行为应遵守本平台规则的相关规定，评价内容应当客观真实，不应包含任何污言秽语、色情低俗、广告信息及法律法规与本协议列明的其他禁止性信息；您不应以不正当方式帮助他人提升信用或利用评价权利对其他用户实施威胁、敲诈勒索。我们可按照本平台规则的相关规定对您实施上述行为所产生的评价信息进行删除或屏蔽。
3.3交易争议处理
您在本平台交易过程中与其他用户发生争议的，您或其他用户中任何一方均有权选择以下途径解决：
与争议相对方自主协商；
使用本平台提供的争议调处服务；
请求消费者协会或者其他依法成立的调解组织调解；
向有关行政部门投诉；
根据与争议相对方达成的仲裁协议（如有）提请仲裁机构仲裁；
向人民法院提起诉讼。
3.4费用
我们为本平台向您提供的服务付出了大量的成本，除本平台明示的收费业务外，我们向您提供的服务目前是免费的。如未来我们向您收取合理费用，我们会采取合理途径并以足够合理的期限提前通过法定程序方式通知您，确保您有充分选择的权利。
3.5责任限制
我们依照法律规定履行基础保障义务，但对于下述原因导致的合同履行障碍、履行瑕疵、履行延后或履行内容变更等情形，我们并不承担相应的违约责任：
因自然灾害、罢工、暴乱、战争、政府行为、司法行政命令等不可抗力因素；
因电力供应故障、通讯网络故障等公共服务因素或第三人因素；
在我们已尽善意管理的情况下，因常规或紧急的设备与系统维护、设备与系统故障、网络信息与数据安全等因素。
四、 用户信息的保护
4.1个人信息的保护
我们非常重视用户个人信息（即能够独立或与其他信息结合后识别用户身份的信息）的保护，我们已采取符合业界标准、合理可行的安全防护措施保护您的信息，防止个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。例如，在您的浏览器与服务器之间交换数据时受SSL协议加密保护；我们同时对本平台提供HTTPS协议安全浏览方式；我们会使用加密技术提高个人信息的安全性；我们会使用受信赖的保护机制防止个人信息遭到恶意攻击；我们会部署访问控制机制，尽力确保只有授权人员才可访问个人信息；以及我们会举办安全培训课程，加强员工对于保护个人信息重要性的认识。
我们会采取合理可行的措施，尽力避免收集无关的个人信息。我们通过本平台账户为您提供基础会员服务。为注册成为会员并使用我们的会员服务，您需要提供手机号码、拟使用的会员名和密码用于创建本平台账户。如果您仅需使用浏览、搜索服务，您不需要注册成为我们的会员及提供上述信息。
在使用本平台服务进行沟通时，请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息尤其是您的账户或密码发生泄露，请您立即联络我们，以便我们根据您的申请采取相应措施。
4.2非个人信息的保证
您声明并保证，您对您所发布的信息拥有相应、合法的权利。否则，我们可对您发布的信息依法或依本协议进行删除或屏蔽。
您应当确保您所发布的信息不包含以下内容：
违反国家法律法规禁止性规定的；
政治宣传、封建迷信、淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；
欺诈、虚假、不准确或存在误导性的；
侵犯他人知识产权或涉及第三方商业秘密及其他专有权利的；
侮辱、诽谤、恐吓、涉及他人隐私等侵害他人合法权益的；
存在可能破坏、篡改、删除、影响本平台任何系统正常运行或未经授权秘密获取本平台及其他用户的数据、个人资料的病毒、木马、爬虫等恶意软件、程序代码的；
其他违背社会公共利益或公共道德或依据相关本平台协议规定不适合在本平台上发布的。
五、 用户的违约及处理
您在本平台上发布的信息构成违约的，我们可根据相应规则立即对相应信息进行删除、屏蔽处理或对您的商品进行下架、监管。
您在本平台上实施的行为，或虽未在本平台上实施但对本平台及其用户产生影响的行为构成违约的，我们可依据相应规则对您执行账户扣分、限制参加营销活动、中止向您提供部分或全部服务、划扣违约金等处理措施。如您的行为构成根本违约的，我们可查封您的账户，终止向您提供服务。
我们可将对您上述违约行为处理措施信息以及其他经国家行政或司法机关生效法律文书确认的违法信息在本平台上予以公示。
六、 协议的变更
我们可根据国家法律法规变化及维护交易秩序、保护消费者权益需要，不时修改本协议，变更后的协议（下称“变更事项”）将通过法定程序并以本协议第七条约定的方式通知您。
如您不同意变更事项，您有权于变更事项确定的生效日前联系我们反馈意见。如反馈意见得以采纳，我们将酌情调整变更事项。
如您对已生效的变更事项仍不同意的，您应当于变更事项确定的生效之日起停止使用本平台服务，变更事项对您不产生效力；如您在变更事项生效后仍继续使用本平台服务，则视为您同意已生效的变更事项。
七、 通知
7.1有效联系方式
您在注册成为本平台用户，并接受本平台服务时，您应该向我们提供真实有效的联系方式（包括您的电子邮件地址、联系电话），对于联系方式发生变更的，您有义务及时更新有关信息，并保持可被联系的状态。
您在注册本平台用户时生成的用于登陆本平台接收站内信、系统消息即时信息的会员账号，也作为您的有效联系方式。
我们将向您的上述联系方式的其中之一或其中若干向您送达各类通知，而此类通知的内容可能对您的权利义务产生重大的有利或不利影响，请您务必及时关注。
您有权通过您注册时填写的手机号码或者电子邮箱获取您感兴趣的商品广告信息、促销优惠等商业性信息；您如果不愿意接收此类信息，您有权通过我们提供的相应的退订功能进行退订。
7.2 通知的送达
我们通过上述联系方式向您发出通知，其中以电子的方式发出的书面通知，包括但不限于在本平台公告，向您提供的联系电话发送手机短信，向您提供的电子邮件地址发送电子邮件，向您的账号发送系统消息以及站内信信息，在发送成功后即视为送达。
你应当保证所提供的联系方式是准确、有效的，并进行实时更新。如果因提供的联系方式不确切，或不及时告知变更后的联系方式，使通知无法送达或未及时送达，由您自行承担由此可能产生的后果。
八、 协议的终止
8.1 终止的情形
您有权通过以下任一方式终止本协议：
在满足我们公示的账户注销条件时您通过网站自助服务注销您的账户的；
变更事项生效前您停止使用并明示不愿接受变更事项的；
您明示不愿继续使用本平台服务，且符合我们终止条件的。
出现以下情况时，我们可以本协议第八条的所列的方式通知您终止本协议：
您违反本协议约定，我们依据违约条款终止本协议的；
您盗用他人账户、发布违禁信息、骗取他人财物、售假、扰乱市场秩序、采取不正当手段谋利等行为，我们依据本平台规则对您的账户予以查封的；
除上述情形外，因您多次违反本平台规则相关规定且情节严重，我们依据本平台规则对您的账户予以查封的；
您的账户被我们依据本协议回收的。
8.2 协议终止后的处理
本协议终止后，除法律有明确规定外，我们无义务向您或您指定的第三方披露您账户中的任何信息。
本协议终止后，我们仍享有下列权利：
对于您过往的违约行为，我们仍可依据本协议向您追究违约责任。
九、 法律适用、管辖与其他
本协议之订立、生效、解释、修订、补充、终止、执行与争议解决均适用中华人民共和国大陆地区法律；如法律无相关规定的，参照商业惯例或行业惯例。
您因使用本平台服务所产生及与本平台服务有关的争议，由我们与您协商解决。协商不成时，任何一方均可向被告所在地有管辖权的人民法院提起诉讼。
本协议任一条款被视为废止、无效或不可执行，该条应视为可分的且并不影响本协议其余条款的有效性及可执行性。
`,
      }).then(() => {
        // on confirm
      }).catch(() => {
        // on cancel
      });
    },
    bbbb() {
      Dialog.confirm({
        title: '用户隐私协议',
        width: '90%',
        showCancelButton: false,
        messageAlign: 'left',
        confirmButtonColor: '#ee0a24',
        message: `我们重视用户的隐私。您在使用我们的服务时，我们可能会收集和使用您的相关信息。我们希望通过本《隐私政策》向您说明，在使用我们的服务时，我们如何收集、使用、储存和分享这些信息，以及我们为您提供的访问、更新、控制和保护这些信息的方式。本《隐私政策》与您所使用的服务息息相关，希望您仔细阅读，在需要时，按照本《隐私政策》的指引，作出您认为适当的选择。本《隐私政策》中涉及的相关技术词汇，我们尽量以简明扼要的表述，并提供进一步说明的链接，以便您的理解。
您使用或继续使用我们的服务，即意味着同意我们按照本《隐私政策》收集、使用、储存和分享您的相关信息。
如对本《隐私政策》或相关事宜有任何问题，请与我们联系。
我们可能收集的信息
我们提供服务时，可能会收集、储存和使用下列与您有关的信息。如果您不提供相关信息，可能无法享受我们提供的某些服务，或者无法达到相关服务拟达到的效果。
您提供的信息
您在使用我们的服务时，向我们提供的相关个人信息，例如电话号码、电子邮件或银行卡号等；
您通过我们的服务向其他方提供的共享信息，以及您使用我们的服务时所储存的信息。
其他方分享的您的信息
其他方使用我们的服务时所提供有关您的共享信息。
我们获取的您的信息
您使用服务时我们可能收集如下信息：
日志信息，指您使用我们的服务时，系统可能通过cookies、web beacon或其他方式自动采集的技术信息，包括：
设备或软件信息，例如您的移动设备、网页浏览器或用于接入我们服务的其他程序所提供的配置信息、您的IP地址和移动设备所用的版本和设备识别码；
在使用我们服务时搜索或浏览的信息，例如您使用的网页搜索词语、访问的社交媒体页面url地址，以及您在使用我们服务时浏览或要求提供的其他信息和内容详情；
有关您曾使用的移动应用（APP）和其他软件的信息，以及您曾经使用该等移动应用和软件的信息；
位置信息，指您开启设备定位功能并使用我们基于位置提供的相关服务时，收集的有关您位置的信息，包括：
您通过具有定位功能的移动设备使用我们的服务时，通过GPS或WiFi等方式收集的您的地理位置信息；
您或其他用户提供的包含您所处地理位置的实时信息，例如您提供的账户信息中包含的您所在地区信息，您或其他人上传的显示您当前或曾经所处地理位置的共享信息；
您可以通过关闭定位功能，停止对您的地理位置信息的收集。
我们可能如何使用信息
我们可能将在向您提供服务的过程之中所收集的信息用作下列用途：
向您提供服务；
在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性；
帮助我们设计新服务，改善我们现有服务；
使我们更加了解您如何接入和使用我们的服务，从而针对性地回应您的个性化需求，例如语言设定、位置设定、个性化的帮助服务和指示，或对您和其他用户作出其他方面的回应；
向您提供与您更加相关的广告以替代普遍投放的广告；
评估我们服务中的广告和其他促销及推广活动的效果，并加以改善；
软件认证或管理软件升级；
让您参与有关我们产品和服务的调查。
为了让您有更好的体验、改善我们的服务或您同意的其他用途，在符合相关法律法规的前提下，我们可能将通过某一项服务所收集的信息，以汇集信息或者个性化的方式，用于我们的其他服务。例如，在您使用我们的一项服务时所收集的信息，可能在另一服务中用于向您提供特定内容，或向您展示与您相关的、非普遍推送的信息。如果我们在相关服务中提供了相应选项，您也可以授权我们将该服务所提供和储存的信息用于我们的其他服务。
您如何访问和控制自己的个人信息
我们将尽一切可能采取适当的技术手段，保证您可以访问、更新和更正自己的注册信息或使用我们的服务时提供的其他个人信息。在访问、更新、更正和删除前述信息时，我们可能会要求您进行身份验证，以保障账户安全。
我们可能分享的信息
除以下情形外，未经您同意，我们不会与任何第三方分享您的个人信息：
我们可能将您的个人信息与第三方服务供应商、承包商及代理（例如代表我们发出电子邮件或推送通知的通讯服务提供商、为我们提供位置数据的地图服务供应商）分享（他们可能并非位于您所在的法域），用作下列用途：
向您提供我们的服务；
实现“我们可能如何使用信息”部分所述目的；
履行我们在本《隐私政策》中的义务和行使我们的权利；
理解、维护和改善我们的服务。
如我们与任何上述第三方分享您的个人信息，我们将努力确保该等第三方在使用您的个人信息时遵守本《隐私政策》及我们要求其遵守的其他适当的保密和安全措施。
随着我们业务的持续发展，我们有可能进行合并、收购、资产转让或类似的交易，您的个人信息有可能作为此类交易的一部分而被转移。我们将在转移前通知您。
我们还可能为以下需要而保留、保存或披露您的个人信息：
遵守适用的法律法规；
遵守法院命令或其他法律程序的规定；
遵守相关政府机关的要求；
为遵守适用的法律法规、维护社会公共利益，或保护我们的客户、我们、其他用户的人身和财产安全或合法权益所合理必需的用途。
信息安全
我们仅在本《隐私政策》所述目的所必需的期间和法律法规要求的时限内保留您的个人信息。 我们使用各种安全技术和程序，以防信息的丢失、不当使用、未经授权阅览或披露。例如，在某些服务中，我们将利用加密技术（例如SSL）来保护您提供的个人信息。但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全。您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。
您分享的信息
我们的多项服务，可让您不仅与自己的社交网络，也与使用该服务的所有用户公开分享您的相关信息，例如，您在我们的服务中所上传或发布的信息（包括您公开的个人信息、您建立的名单）、您对其他人上传或发布的信息作出的回应，以及包括与这些信息有关的位置数据和日志信息。使用我们服务的其他用户也有可能分享与您有关的信息（包括位置数据和日志信息）。特别是，我们的社交媒体服务，是专为使您与世界各地的用户共享信息而设计，您可以使共享信息实时、广泛地传递。只要您不删除共享信息，有关信息会一直留存在公共领域；即使您删除共享信息，有关信息仍可能由其他用户或不受我们控制的非关联第三方独立地缓存、复制或储存，或由其他用户或该等第三方在公共领域保存。
因此，请您谨慎考虑通过我们的服务上传、发布和交流的信息内容。在一些情况下，您可通过我们某些服务的隐私设定来控制有权浏览您共享信息的用户范围。如要求从我们的服务中删除您的相关信息，请通过该等特别服务条款提供的方式操作。
您分享的敏感个人信息
某些个人信息因其特殊性可能被认为是敏感个人信息，例如您的种族、宗教、个人健康和医疗信息等。相比其他个人信息，敏感个人信息受到更加严格的保护。
请注意，您在使用我们的服务时所提供、上传或发布的内容和信息（例如有关您社交活动的照片等信息），可能会泄露您的敏感个人信息。您需要谨慎地考虑，是否在使用我们的服务时披露相关敏感个人信息。
您同意按本《隐私政策》所述的目的和方式来处理您的敏感个人信息。
我们可能如何收集信息
我们或我们的第三方合作伙伴，可能通过cookies和web beacon收集和使用您的信息，并将该等信息储存为日志信息。
我们使用自己的cookies和web beacon，目的是为您提供更个性化的用户体验和服务，并用于以下用途：
记住您的身份。例如：cookies和web beacon有助于我们辨认您作为我们的注册用户的身份，或保存您向我们提供的有关您的喜好或其他信息；
分析您使用我们服务的情况。例如，我们可利用cookies和web beacon来了解您使用我们的服务进行什么活动，或哪些网页或服务最受您的欢迎；
广告优化。Cookies和web beacon有助于我们根据您的信息，向您提供与您相关的广告而非进行普遍的广告投放。
我们为上述目的使用cookies和web beacon的同时，可能将通过cookies和web beacon收集的非个人身份信息，经统计加工后提供给广告商或其他合作伙伴，用于分析用户如何使用我们的服务，并用于广告服务。
我们的产品和服务上可能会有广告商或其他合作方放置的cookies和web beacon。这些cookies和web beacon可能会收集与您相关的非个人身份信息，以用于分析用户如何使用该等服务、向您发送您可能感兴趣的广告，或用于评估广告服务的效果。这些第三方cookies和web beacon收集和使用该等信息，不受本《隐私政策》约束，而是受相关使用者的隐私政策约束，我们不对第三方的cookies或web beacon承担责任。
您可以通过浏览器设置拒绝或管理cookies或web beacon。但请注意，如果停用cookies或web beacon，您有可能无法享受最佳的服务体验，某些服务也可能无法正常使用。同时，您还会收到同样数量的广告，但这些广告与您的相关性会降低。
广告服务
我们可能使用您的相关信息，向您提供与您更加相关的广告。
我们也可能使用您的信息，通过我们的服务、电子邮件或其他方式向您发送营销信息，提供或推广我们或第三方的如下商品和服务：
我们的服务，我们的关联公司和合作伙伴的商品或服务，包括即时通讯服务、网上媒体服务、互动娱乐服务、社交网络服务、付款服务、互联网搜索服务、位置和地图服务、应用软件和服务、数据管理软件和服务、网上广告服务、互联网金融，以及其他社交媒体、娱乐、电子商务、资讯和通讯软件或服务（统称“互联网服务”）；
第三方互联网服务供应商，以及与下列有关的第三方商品或服务：食物和餐饮、体育、音乐、电影、电视、现场表演及其他艺术和娱乐、书册、杂志和其他刊物、服装和配饰、珠宝、化妆品、个人健康和卫生、电子、收藏品、家用器皿、电器、家居装饰和摆设、宠物、汽车、酒店、交通和旅游、银行、保险及其他金融服务、会员积分和奖励计划，以及我们认为可能与您相关的其他商品或服务。

如您不希望我们将您的个人信息用作前述广告用途，您可以通过我们在广告中提供的相关提示，或在特定服务中提供的指引，要求我们停止为上述用途使用您的个人信息。
我们可能向您发送的邮件和信息
邮件和信息推送
您在使用我们的服务时，我们可能使用您的信息向您的设备发送电子邮件、新闻或推送通知。如您不希望收到这些信息，可以按照我们的相关提示，在设备上选择取消订阅。
与服务有关的公告
我们可能在必要时（例如因系统维护而暂停某一项服务时）向您发出与服务有关的公告。您可能无法取消这些与服务有关、性质不属于推广的公告。
隐私政策的适用例外
我们的服务可能包括或链接至第三方提供的社交媒体或其他服务（包括网站）。例如：
您利用 “分享”键将某些内容分享到我们的服务，或您利用第三方连线服务登录我们的服务。这些功能可能会收集您的相关信息（包括您的日志信息），并可能在您的电脑装置cookies，从而正常运行上述功能；
我们通过广告或我们服务的其他方式向您提供链接，使您可以接入第三方的服务或网站。
该等第三方社交媒体或其他服务可能由相关的第三方或我们运营。您使用该等第三方的社交媒体服务或其他服务（包括您向该等第三方提供的任何个人信息），须受该第三方的服务条款及隐私政策（而非《通用服务条款》或本《隐私政策》）约束，您需要仔细阅读其条款。本《隐私政策》仅适用于我们所收集的信息，并不适用于任何第三方提供的服务或第三方的信息使用规则，我们对任何第三方使用由您提供的信息不承担任何责任。
未成年人使用我们的服务
我们鼓励父母或监护人指导未满十八岁的未成年人使用我们的服务。我们建议未成年人鼓励他们的父母或监护人阅读本《隐私政策》，并建议未成年人在提交的个人信息之前寻求父母或监护人的同意和指导。
隐私政策的适用范围
除某些特定服务外，我们所有的服务均适用本《隐私政策》。这些特定服务将适用特定的隐私政策。针对某些特定服务的特定隐私政策，将更具体地说明我们在该等服务中如何使用您的信息。该特定服务的隐私政策构成本《隐私政策》的一部分。如相关特定服务的隐私政策与本《隐私政策》有不一致之处，适用该特定服务的隐私政策。
请您注意，本《隐私政策》不适用于以下情况：
通过我们的服务而接入的第三方服务（包括任何第三方网站）收集的信息；
通过在我们服务中进行广告服务的其他公司或机构所收集的信息。
变更
我们可能适时修订本《隐私政策》的条款，该等修订构成本《隐私政策》的一部分。如该等修订造成您在本《隐私政策》下权利的实质减少，我们将在修订生效前通过在主页上显著位置提示或向您发送电子邮件或以其他方式通知您。在该种情况下，若您继续使用我们的服务，即表示同意受经修订的本《隐私政策》的约束。`,
      }).then(() => {
        // on confirm
      }).catch(() => {
        // on cancel
      });
    },

  }
}
</script>
<style lang="less" scoped>
.page {
  background: #f7f8fa;
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;

  .main {
    flex: 1;
    display: flex;
    align-items: stretch;
    flex-direction: column;

    .login {
      margin: 60px 0px 0px 24px;
      font-size: 28px;
      color: rgb(6, 18, 30);
      font-weight: bold;
    }

    .login-text {
      color: #707070;
      font-size: 16px;
      margin-left: 24px;
      margin-top: 14px;
      line-height: 20px;
      width: 90%;
    }

    .captcha {
      display: flex;
      justify-content: center;
      margin-top: 40px;
    }

    input {
      margin-right: 20px;
      width: 45px;
      text-align: center;
      border: none;
      border-bottom: 1px solid #212121;
      font-size: 24px;
      outline: none;
      background: none;
    }

    input:last-of-type {
      margin-right: 0;
    }

    input:disabled {
      color: #000;
      background-color: #fff;
    }

    .point {
      flex-direction: row;
      margin-top: 37px;
      justify-content: center;
      display: flex;
      font-size: 17px;
      color: #707070;
      margin-bottom: 36px;

      .once {
        color: #0c62ee;
      }
    }

    .ph-input {
      margin: 40px 24px 20px;
      height: 60px;
      border-bottom: 1px solid #e3e2e2;
      flex-direction: row;
      align-items: center;
      flex-grow: 0;
      display: flex;

      .ph-text {
        color: #06121e;
        width: 50px;
        line-height: 50px;
        height: 50px;
        font-size: 17px;
      }

      .ph-t {
        color: #06121e;
        flex: 1;
        line-height: 50px;
        height: 50px;
        font-size: 17px;
        padding: 0;
        background: none;

        ::v-deep .van-field__left-icon {
          .van-icon {
            font-size: 22px;
          }
        }

        ::v-deep.van-cell__value {
          .van-field__control {
            background: none;
            padding-left: 14px;
            color: #000;

            // font-weight: bold;
            &::-webkit-input-placeholder {
              color: #000;
            }
          }
        }
      }
    }

    .bu_tn {
      width: 230px;
      height: 50px;
      line-height: 50px;
      background: rgba(52, 118, 254, .1) !important;
      color: #3476fe;
      border: 0 !important;
      border-radius: 94px;
      font-size: 16px;
      align-self: center;
      text-align: center;
    }

    .bu_tn-a {
      width: 230px;
      height: 50px;
      line-height: 50px;
      background: #3476fe !important;
      color: #fff;
      border: 0 !important;
      border-radius: 94px;
      font-size: 16px;
      align-self: center;
      text-align: center;
    }

    .tis {
      font-size: 18px;
      font-weight: 600;
      margin-top: 40px;
      margin-left: 24px;
    }

    .tis-small {
      font-size: 12px;
      margin-left: 24px;
      padding-top: 10px;
      width: 90%;
      line-height: 22px;
      color: #666;
    }
  }

  .agree {
    display: flex;
    width: 300px;
    position: fixed;
    bottom: 25px;
    flex-direction: row;
    justify-content: center;
    margin: auto;
    left: 0;
    right: 0;
    text-align: center;
    line-height: 20px;

    .van-checkbox {
      margin-right: 6px;
      width: 30px;

      ::v-deep .van-icon {
        width: 1em;
        height: 1em;
        line-height: 1;
      }
    }

    span {
      color: #0c62ee;
      display: contents;
    }
  }
}

.checkbox-info {
  width: 85%;
  margin: 10px auto;
  font-size: 12px;

  .van-checkbox {
    display: inline-block;
    margin-top: 4px;
  }
}

.van-dialog {
  ::v-deep.van-dialog__content {
    flex-direction: column;
    justify-content: center;
    background-color: #fff;
    padding: 20px;
    border-radius: 10px;

    .captcha {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }

    input {
      margin-right: 20px;
      width: 45px;
      text-align: center;
      border: none;
      border-bottom: 1px solid #212121;
      font-size: 24px;
      outline: none;
      background: none;
    }

    input:last-of-type {
      margin-right: 0;
    }

    input:disabled {
      color: #000;
      background-color: #fff;
    }

    .point {
      flex-direction: row;
      margin-top: 37px;
      justify-content: center;
      display: flex;
      font-size: 17px;
      color: #707070;
      margin-bottom: 36px;

      .once {
        color: #0c62ee;
      }
    }
  }

  ::v-deep .van-dialog__header {
    font-size: 20px;
    font-weight: 700;
    color: #06121e;
    text-align: center;
    margin-bottom: 10px;
  }

  .dialog-text {
    font-size: 14px;
    color: #06121e;
    margin-top: 8px;
    line-height: 28px;
  }

  .btn-vis {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 25px;

    .dialog-btn2 {
      width: 120px;
      height: 47px;
      color: #3476fe;
      text-align: center;
      background: rgba(52, 118, 254, 0.1) !important;
      border: 0 !important;
      border-radius: 94px;
      font-size: 16px;
      line-height: 47px;
    }

    .dialog-btn3 {
      width: 130px;
      height: 47px;
      border-radius: 94px;
      font-size: 16px;
      line-height: 47px;
      border: 0;
      color: #fff;
      background: #3476fe;
      text-align: center;
    }
  }

}
</style>

